import { render, staticRenderFns } from "./already-using.vue?vue&type=template&id=6a0f12d4&scoped=true"
var script = {}
import style0 from "./already-using.vue?vue&type=style&index=0&id=6a0f12d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f12d4",
  null
  
)

export default component.exports